module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst title = model.meta.title = model.meta.title || model.name || model.nameSEO || storage.__('error:unknownPageTitle')\nconst loadRootOnlyBundle = helpers.hasAccessTo('loggedIn', 'common') && helpers.hasAccessTo('usage:load_root_only_bundle', 'routeTree')\nconst bodyAttributes = ['']\nconst bodyClasses = utils.environment.getBodyClasses(environment)\nif(bodyClasses.length > 0){\nbodyAttributes.push(`class=\"${bodyClasses.join(' ')}\"`)\n}\n// TODO: i would love to use the strict mode via doctype (<!doctype html>), but only if one finds a solution for the:\n//  \t\t.base_form_fields_autoComplete .optionList margin-bottom: 100% during strict mode problem.\n%><html lang=\"<%= model.lang %>\">\n<head>\n<!-- meta tags -->\n<title><%= title %></title>\n<meta name=\"viewport\" content=\"user-scalable=no,initial-scale=1.0, minimum-scale=1.0,maximum-scale=1.0\">\n<% for(const [metaName, metaContent] of Object.entries(model.meta || {})){ %>\n<meta name=\"<%= metaName %>\" content=\"<%= metaContent %>\" />\n<% } %>\n<!-- favicons -->\n<link rel=\"apple-touch-icon\" sizes=\"57x57\" href=\"/favicon/apple-icon-57x57.png\">\n<link rel=\"apple-touch-icon\" sizes=\"60x60\" href=\"/favicon/apple-icon-60x60.png\">\n<link rel=\"apple-touch-icon\" sizes=\"72x72\" href=\"/favicon/apple-icon-72x72.png\">\n<link rel=\"apple-touch-icon\" sizes=\"76x76\" href=\"/favicon/apple-icon-76x76.png\">\n<link rel=\"apple-touch-icon\" sizes=\"114x114\" href=\"/favicon/apple-icon-114x114.png\">\n<link rel=\"apple-touch-icon\" sizes=\"120x120\" href=\"/favicon/apple-icon-120x120.png\">\n<link rel=\"apple-touch-icon\" sizes=\"144x144\" href=\"/favicon/apple-icon-144x144.png\">\n<link rel=\"apple-touch-icon\" sizes=\"152x152\" href=\"/favicon/apple-icon-152x152.png\">\n<link rel=\"apple-touch-icon\" sizes=\"180x180\" href=\"/favicon/apple-icon-180x180.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"192x192\"  href=\"/favicon/android-icon-192x192.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"32x32\" href=\"/favicon/favicon-32x32.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"96x96\" href=\"/favicon/favicon-96x96.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"16x16\" href=\"/favicon/favicon-16x16.png\">\n<link rel=\"manifest\" href=\"/favicon/manifest.json\">\n<meta name=\"msapplication-TileColor\" content=\"#ffffff\">\n<meta name=\"msapplication-TileImage\" content=\"/favicon/ms-icon-144x144.png\">\n<meta name=\"theme-color\" content=\"#ffffff\">\n<!-- css sources -->\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~app.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/app.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<% if(loadRootOnlyBundle){ %>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~rootOnly.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<% } %>\n</head>\n<body<%- bodyAttributes.join(' ') %>>\n<!-- sections -->\n<div class=\"appContainer\">\n<section class=\"status\">\n<%- include('../../templates/nav/controller') %>\n<%- helpers.renderSection('status', false) %>\n</section>\n<%- helpers.renderSection('top') %>\n<section class=\"content\">\n<%- helpers.renderSection('mainMenu', false) %>\n<%- helpers.renderSection('main') %>\n<%- helpers.renderSection('login') %>\n</section>\n</div>\n<!-- js server sources -->\n<script type=\"application/javascript\" class=\"dynamicJSSources\">\nglobalThis.route \t\t\t\t= \"<%= model.route || '' %>\";\nglobalThis.tree \t\t\t\t= <%- model.tree || 'null' %>;\nglobalThis.globalActionsByScope = <%- model.globalActionsByScope || 'null' %>;\nglobalThis.updateClientStorage \t= <%- model.updateClientStorage || 'null' %>;\nglobalThis.routeParams \t\t\t= <%- model.routeParams || {} %>;\n</script>\n<!-- js sources -->\n<script type=\"text/javascript\" src=\"/webpack/js/vendors~app.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/app.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<% if(loadRootOnlyBundle){ %>\n<script type=\"text/javascript\" src=\"/webpack/js/vendors~rootOnly.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/rootOnly.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<% } %>\n</body>\n</html>"
  , __filename = "components/layouts/master/master.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const title = model.meta.title = model.meta.title || model.name || model.nameSEO || storage.__('error:unknownPageTitle')
const loadRootOnlyBundle = helpers.hasAccessTo('loggedIn', 'common') && helpers.hasAccessTo('usage:load_root_only_bundle', 'routeTree')
const bodyAttributes = ['']
const bodyClasses = utils.environment.getBodyClasses(environment)
if(bodyClasses.length > 0){
bodyAttributes.push(`class="${bodyClasses.join(' ')}"`)
}
// TODO: i would love to use the strict mode via doctype (<!doctype html>), but only if one finds a solution for the:
//  		.base_form_fields_autoComplete .optionList margin-bottom: 100% during strict mode problem.

    ; __line = 11
    ; __append("<html lang=\"")
    ; __append(escapeFn( model.lang ))
    ; __append("\">\n<head>\n<!-- meta tags -->\n<title>")
    ; __line = 14
    ; __append(escapeFn( title ))
    ; __append("</title>\n<meta name=\"viewport\" content=\"user-scalable=no,initial-scale=1.0, minimum-scale=1.0,maximum-scale=1.0\">\n")
    ; __line = 16
    ;  for(const [metaName, metaContent] of Object.entries(model.meta || {})){ 
    ; __append("\n<meta name=\"")
    ; __line = 17
    ; __append(escapeFn( metaName ))
    ; __append("\" content=\"")
    ; __append(escapeFn( metaContent ))
    ; __append("\" />\n")
    ; __line = 18
    ;  } 
    ; __append("\n<!-- favicons -->\n<link rel=\"apple-touch-icon\" sizes=\"57x57\" href=\"/favicon/apple-icon-57x57.png\">\n<link rel=\"apple-touch-icon\" sizes=\"60x60\" href=\"/favicon/apple-icon-60x60.png\">\n<link rel=\"apple-touch-icon\" sizes=\"72x72\" href=\"/favicon/apple-icon-72x72.png\">\n<link rel=\"apple-touch-icon\" sizes=\"76x76\" href=\"/favicon/apple-icon-76x76.png\">\n<link rel=\"apple-touch-icon\" sizes=\"114x114\" href=\"/favicon/apple-icon-114x114.png\">\n<link rel=\"apple-touch-icon\" sizes=\"120x120\" href=\"/favicon/apple-icon-120x120.png\">\n<link rel=\"apple-touch-icon\" sizes=\"144x144\" href=\"/favicon/apple-icon-144x144.png\">\n<link rel=\"apple-touch-icon\" sizes=\"152x152\" href=\"/favicon/apple-icon-152x152.png\">\n<link rel=\"apple-touch-icon\" sizes=\"180x180\" href=\"/favicon/apple-icon-180x180.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"192x192\"  href=\"/favicon/android-icon-192x192.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"32x32\" href=\"/favicon/favicon-32x32.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"96x96\" href=\"/favicon/favicon-96x96.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"16x16\" href=\"/favicon/favicon-16x16.png\">\n<link rel=\"manifest\" href=\"/favicon/manifest.json\">\n<meta name=\"msapplication-TileColor\" content=\"#ffffff\">\n<meta name=\"msapplication-TileImage\" content=\"/favicon/ms-icon-144x144.png\">\n<meta name=\"theme-color\" content=\"#ffffff\">\n<!-- css sources -->\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~app.css?usTS=")
    ; __line = 38
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/app.css?usTS=")
    ; __line = 39
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n")
    ; __line = 40
    ;  if(loadRootOnlyBundle){ 
    ; __append("\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~rootOnly.css?usTS=")
    ; __line = 41
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n")
    ; __line = 42
    ;  } 
    ; __append("\n</head>\n<body")
    ; __line = 44
    ; __append( bodyAttributes.join(' ') )
    ; __append(">\n<!-- sections -->\n<div class=\"appContainer\">\n<section class=\"status\">\n")
    ; __line = 48
    ; __append( include('../../templates/nav/controller') )
    ; __append("\n")
    ; __line = 49
    ; __append( helpers.renderSection('status', false) )
    ; __append("\n</section>\n")
    ; __line = 51
    ; __append( helpers.renderSection('top') )
    ; __append("\n<section class=\"content\">\n")
    ; __line = 53
    ; __append( helpers.renderSection('mainMenu', false) )
    ; __append("\n")
    ; __line = 54
    ; __append( helpers.renderSection('main') )
    ; __append("\n")
    ; __line = 55
    ; __append( helpers.renderSection('login') )
    ; __append("\n</section>\n</div>\n<!-- js server sources -->\n<script type=\"application/javascript\" class=\"dynamicJSSources\">\nglobalThis.route 				= \"")
    ; __line = 60
    ; __append(escapeFn( model.route || '' ))
    ; __append("\";\nglobalThis.tree 				= ")
    ; __line = 61
    ; __append( model.tree || 'null' )
    ; __append(";\nglobalThis.globalActionsByScope = ")
    ; __line = 62
    ; __append( model.globalActionsByScope || 'null' )
    ; __append(";\nglobalThis.updateClientStorage 	= ")
    ; __line = 63
    ; __append( model.updateClientStorage || 'null' )
    ; __append(";\nglobalThis.routeParams 			= ")
    ; __line = 64
    ; __append( model.routeParams || {} )
    ; __append(";\n</script>\n<!-- js sources -->\n<script type=\"text/javascript\" src=\"/webpack/js/vendors~app.js?usTS=")
    ; __line = 67
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/app.js?usTS=")
    ; __line = 68
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n")
    ; __line = 69
    ;  if(loadRootOnlyBundle){ 
    ; __append("\n<script type=\"text/javascript\" src=\"/webpack/js/vendors~rootOnly.js?usTS=")
    ; __line = 70
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/rootOnly.js?usTS=")
    ; __line = 71
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n")
    ; __line = 72
    ;  } 
    ; __append("\n</body>\n</html>")
    ; __line = 74
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/layouts/master/master.ejs

}